import React from 'react';

const BusinessTag = (props) => {
  return (
    <span
      style={{
        backgroundColor: 'lightgray',
        borderRadius: '4px',
        padding: '2px 0.25rem',
        verticalAlign: 'middle',
        fontSize: '0.625em',
      }}
    >
      {props.text}
    </span>
  );
};

const BusinessTags = (props) => {
  return props.tags.map((tag) => <BusinessTag text={tag} />);
};

export default BusinessTags;
